export default "/packs/images/default_423x550~04c3bb6ea3d887fc3ef20987291442d0.png";